<template>
    <v-combobox v-bind="{ ...attrs_select_common, ...$attrs }">
        <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
            <slot :name="slotName" />
        </template>
    </v-combobox>
</template>

<script>
import { attrs_select_common } from "@/assets/variables";

export default {
    props: {},
    components: {},
    data() {
        return {
            attrs_select_common,
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
